
import hazelnut2 from "../assets/images/products/Hazelnut-Heritage-2.jpg";
import hazelnut3 from "../assets/images/products/Hazelnut-Heritage-3.jpg";
import vanilla1 from "../assets/images/products/Vanilla-Euphoria-1.jpg";
import vanilla2 from "../assets/images/products/Vanilla-Euphoria-2.jpg";

import caramel2 from "../assets/images/products/Caramel-Epoque-2.jpg";
import caramel3 from "../assets/images/products/Caramel-Epoque-3.jpg";
import discovery1 from "../assets/images/products/Coffee-Gable-Coffee-Discovery-1.jpg";
import discovery2 from "../assets/images/products/Coffee-Gable-Coffee-Discovery-2.jpg";
import discovery3 from "../assets/images/products/Coffee-Gable-Coffee-Discovery-3.jpg";
import discovery4 from "../assets/images/products/Coffee-Gable-Coffee-Discovery-4.jpg";
import discovery5 from "../assets/images/products/Coffee-Gable-Coffee-Discovery-5.jpg";

export const FLAVOURED_INSTANT_COFFEE_PRODUCTS = {
  501: {
    _id: 501,
    id: 501,
    productName: "Hazelnut Heritage",
    price: 425,
    gram: "65g",
    images: [hazelnut2, hazelnut3],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p><strong>Hazelnut Flavoured Instant Coffee</strong></p>
<p>Experience the timeless charm of bold coffee infused with rich hazelnut, crafted for a smooth, aromatic cup with elegant nutty notes in every sip.</p>
<p><strong>Savour the Heritage</strong><br />Sip slowly, hot or iced, and let each cup carry the warmth of a timeless hazelnut aroma.</p>
<p><strong>Ingredients:</strong> Coffee Beans, Natural Hazelnut Flavouring</p>
<p><strong>Serving Ritual:</strong><br />Add 1–2 teaspoons (approx. 2 g) to a cup.<br />Pour hot water or milk (120–150 ml).<br />Add a spoon of sugar (optional).<br />Stir gently and savour.</p>
<p>Naturally Flavoured with Hazelnut<br />No Added Sugar<br />No Preservatives<br />Vegan<br />Gluten-Free</p>`,
  },
  502: {
    _id: 502,
    id: 502,
    productName: "Vanilla Euphoria",
    price: 425,
    gram: "65g",
    images: [vanilla1, vanilla2],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p><strong>Vanilla Flavored Instant Coffee</strong></p>
<p>Indulge in the perfect blend of rich coffee and smooth vanilla with our Vanilla-Flavored Instant Coffee. A delicate harmony of vanilla warmth and pure coffee clarity.</p>
<p><strong>Brewed to Bloom</strong><br />Pour hot or cold water or milk. Add sugar (optional), inhale the aroma, and sip into serenity. Let Vanilla Euphoria be your sweet pause in the day.</p>
<p><strong>Ingredients:</strong> Coffee Beans, Natural Vanilla Flavouring</p>
<p>Made with Love &amp; Purity<br />Naturally Flavoured with Vanilla<br />No Added Sugar<br />No Preservatives<br />Vegan &amp; Gluten-Free</p>`,
  },
  503: {
    _id: 503,
    id: 503,
    productName: "Caramel Époque",
    price: 425,
    gram: "65g",
    images: [caramel2, caramel3],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p><strong>Caramel Flavoured Instant Coffee</strong></p>
<p><strong>Crafted by Coffee Gable. Inspired by the Belle Époque.</strong></p>
<p>Savour the rich, velvety smoothness of Caramel Époque, a luxurious coffee infused with warm, golden caramel notes.</p>
<p><strong>Ingredients:</strong> Coffee Beans, Natural Caramel Flavouring</p>
<p><strong>Brew It Your Way:</strong><br />Enjoy hot or iced, black or with milk.</p>
<p>Naturally Flavoured with Caramel<br />No Preservatives<br />Vegan<br />Gluten-Free</p>`,
  },
  504: {
    _id: 504,
    id: 504,
    productName: "Coffee Gable Coffee Discovery Set",
    price: 295,
    gram: "10 bottles × 8 g each · Net weight 80 g",
    images: [discovery1, discovery2, discovery3, discovery4, discovery5],
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: `<p><strong>Five Coffees. Ten Tiny Bottles. Endless Ways to Enjoy Coffee.</strong></p>
<p>Discover the world of Coffee Gable with this assorted set of 10 mini bottles, featuring five distinctive coffees. From the pure, smooth taste of Vintage to the bold character of Jolt and the indulgent flavours of Hazelnut Heritage, Caramel Époque and Vanilla Euphoria, there’s a coffee for every mood.</p>
<p><strong>2 × Vintage (8 g each)</strong> – 100% pure instant freeze-dried coffee.<br /><strong>2 × Jolt (8 g each)</strong> – Bold, strong and flavourful instant coffee with chicory.<br /><strong>2 × Hazelnut Heritage (8 g each)</strong> – Coffee with the delightful flavour of hazelnut.<br /><strong>2 × Caramel Époque (8 g each)</strong> – Coffee with rich caramel flavour.<br /><strong>2 × Vanilla Euphoria (8 g each)</strong> – Coffee with smooth vanilla flavour.</p>
<p>Five distinctive coffee experiences in one set.<br />Convenient mini bottles, perfect for sampling and discovering your favourites.<br />Ideal for travel, gifting or your everyday coffee moments.<br />Enjoy your coffee hot or iced, according to your preference.</p>
<p><strong>A Little Bottle of Coffee. A Whole Lot to Discover.</strong></p>`,
  },
};

export function getFlavouredInstantCoffeeProduct(id) {
  return FLAVOURED_INSTANT_COFFEE_PRODUCTS[id];
}
